import React, { useContext, useEffect, useState } from 'react';

// Styles & Assets
import styles from './PatientAssistentialStaff.module.css';
import { ReactComponent as PersonAdd } from '../../../assets/icons/person-add.svg';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';
import { getFullName } from '../../../services/getPatientAtribute';

// Context
import FiltersContext from '../../../context/FiltersContext';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Components
import ContactPersonButton from '../ContactPersonButton/ContactPersonButton';
import AddAssistentialStaff from '../AddAssistentialStaff/AddAssistentialStaff';
import Modal from '../../UI/Modal/Modal';
import PatientInfoTitle from '../PatientInfoTitle/PatientInfoTitle';

// Models
import { UserData } from '../../../interfaces/UserInfo';
interface PatientUser {
    id: number
    patient_id: number
    user_id: number
}
interface Props {
    patientID: number
    disabledAdding: boolean
}

const PatientAssistentialStaff: React.FC<Props> = ({ patientID, disabledAdding }) => {

    const { t } = useTranslation();

    const [showAddStaff, setShowAddStaff] = useState(false);

    const { profiles } = useContext(FiltersContext);

    const [assistentialStaff, setAssistentialStaff] = useState<UserData[]>([]);
    const [patientUsers, setPatientUsers] = useState<PatientUser[]>([]);

    const { sendRequest } = useHttp<UserData[]>();
    const { sendRequest: getPatientUser } = useHttp<PatientUser[]>();

    useEffect(() => {
        getPatientUser({
            url: getEnvironmentApiUrl() + 'patient_users/all',
            method: 'POST',
            body: {
                params: {},
                filter: { patient_id: patientID }
            }
        }, (data) => setPatientUsers(data));
        sendRequest({
            url: getEnvironmentApiUrl() + 'user/all',
            method: 'POST',
            body: {
                params: {},
                filter: { is_clinical_staff: true, enabled_bchome: true }
            },
        }, (data) => {
            setAssistentialStaff(data);
        });
    }, [getPatientUser, patientID, sendRequest]);

    const deleteUser = (id: number) => {
        const deleteUsers = patientUsers.filter(pu => pu.user_id === id);
        deleteUsers.forEach(pu => {
            sendRequest({
                url: getEnvironmentApiUrl() + 'patient_users/' + pu.id,
                method: 'DELETE',
                body: { patient_id: patientID, user_id: id }
            }, () => {
                setPatientUsers(oldUsers => oldUsers.filter(u => u.user_id !== id));
            });
        });
    };

    const onConfirm = (addedUser: PatientUser) => {
        setPatientUsers(oldUsers => [...oldUsers, addedUser]);
    };

    const filteredStaff = assistentialStaff.filter(s => patientUsers.some(pu => pu.user_id === s.id));
    const nonAddedStaff = assistentialStaff.filter(s => !patientUsers.some(pu => pu.user_id === s.id));


    return (
        <div>
            <PatientInfoTitle
                title={t('assistential_staff')}
                onClick={() => setShowAddStaff(true)}
                disabled={disabledAdding}
                size={36}
            >
                <PersonAdd />
            </PatientInfoTitle>
            <div className={styles.userList}>
                {filteredStaff.map(user =>
                    <ContactPersonButton
                        key={user.id}
                        handleClickContact={() => {/* */ }}
                        handleDeleteContact={() => deleteUser(user.id)}
                        title={<>{getFullName(user)}</>}
                        subtitles={[profiles.find(p => p.id === user.profile_id)?.name ?? '-']}
                    />
                )}
            </div>

            <Modal show={showAddStaff} setShowModal={setShowAddStaff} secondModal>
                <AddAssistentialStaff
                    assistentialStaff={nonAddedStaff}
                    patientID={patientID}
                    closeModal={() => setShowAddStaff(false)}
                    onConfirm={onConfirm}
                />
            </Modal>
        </div>
    );
};

export default PatientAssistentialStaff;